const zhCN = {
  app: {
    title: '东方玄学'
  },
  language: {
    label: '语言',
    simplifiedChinese: '简体中文',
    traditionalChinese: '繁體中文',
    english: 'English'
  },
  common: {
    requestFailed: '请求失败',
    networkError: '网络错误',
    sessionExpired: '登录状态已失效，请重新登录',
    confirm: '确定',
    cancel: '取消',
    back: '返回',
    loading: '加载中...',
    noData: '暂无数据',
    save: '保存',
    saving: '保存中...',
    delete: '删除',
    edit: '编辑',
    view: '查看',
    previous: '上一步',
    next: '下一步',
    male: '男',
    female: '女',
    solarCalendar: '公历',
    lunarCalendar: '农历'
  },
  loading: {
    tagline: '东方命理 + 智慧指引',
    entering: '正在进入{dots}',
    progress: '加载中 {progress}%'
  },
  activation: {
    login: '登录',
    title: '请完成激活',
    description: '当前账号尚未激活，完成激活后才可继续使用',
    loggedIn: '账号已登录，继续完成激活',
    phoneHint: '当前手机号已自动注册，请先完成首次激活',
    emailHint: '当前邮箱已自动注册，请先完成首次激活',
    accountHint: '当前账号尚未激活，请先完成首次激活',
    placeholder: '请输入激活码',
    activating: '激活中...',
    activate: '激活并继续',
    backToLogin: '返回登录',
    required: '请输入激活码',
    loginInvalid: '登录状态异常，请重新登录',
    success: '激活成功'
  },
  home: {
    slogan: '先起卦，后提问，再解读',
    intro: '通过三次乾坤选择，开启本次卜卦咨询',
    account: '账号',
    profiles: '档案',
    results: '结果',
    divinationFirst: '先起卦',
    calmSelection: '静心选择',
    questionsSecond: '后提问',
    focusQuestion: '聚焦所问',
    interpretationThird: '再解读',
    receiveGuidance: '获得指引',
    start: '开始起卦',
    submitted: '已提交解析请求，请稍后在结果列表查看'
  },
  divination: {
    title: '起卦',
    guide: '使用指南',
    instruction: '请集中精神，点击上方乾坤选择，然后点击起卦',
    completed: '已完成 {count}/3',
    starting: '起卦中...',
    start: '起卦',
    qian: '乾',
    kun: '坤',
    selection: '第{index}次选择：{value}',
    firstSelection: '请先完成第 1 次选择',
    allSelected: '已完成 3 次选择，可直接起卦',
    incomplete: '请先完成 3 次乾坤选择'
  },
  hexagram: {
    title: '卦象解读',
    continue: '继续解读',
    result: '卦象结果',
    generated: '本次卦象已生成，可继续进入三问并开始解析。',
    movingLine: '动爻'
  },
  login: {
    title: '登录',
    welcome: '欢迎回来',
    subtitle: '请登录以继续使用',
    mobile: '手机号',
    email: '邮箱',
    mobilePlaceholder: '请输入手机号',
    emailPlaceholder: '请输入邮箱地址',
    codePlaceholder: '请输入验证码',
    getCode: '获取验证码',
    agreementPrefix: '我已阅读并同意',
    userAgreement: '用户协议',
    and: '和',
    privacyPolicy: '隐私政策',
    signingIn: '登录中...',
    submit: '登录 / 注册',
    mobileAutoRegister: '未注册账号将自动注册',
    mainlandOnly: '仅支持中国大陆手机号',
    emailAutoRegister: '未注册邮箱将自动注册',
    mobileInvalid: '请输入正确的手机号',
    emailInvalid: '请输入正确的邮箱地址',
    codeSent: '验证码已发送',
    agreementRequired: '请先阅读并同意协议',
    codeRequired: '请输入验证码',
    registerSuccess: '注册并登录成功',
    success: '登录成功'
  },
  question: {
    pageTitle: '问题信息',
    title: '填写问题',
    subtitle: '请按顺序回答以下问题',
    next: '下一步',
    previous: '上一步',
    reveal: '揭秘天机',
    first: '1. 你这次想问的是什么事？',
    second: '2. 这件事急不急？',
    third: '3. 是你自己的事吗？若不是，对方是你什么人？',
    firstPlaceholder: '请详细描述您的问题...',
    secondPlaceholder: '请描述事情的紧急程度...',
    thirdPlaceholder: '请描述相关关系...',
    divinationRequired: '请先完成起卦',
    contentRequired: '请先填写内容',
    tooLong: '当前问题最多输入{max}字'
  },
  consultConfig: {
    title: '解析配置',
    selectAgent: '选择智能体',
    selectProfile: '选择档案',
    dateMissing: '日期待补充',
    addressMissing: '出生地点待补充',
    selected: '已选择',
    select: '选择',
    noProfiles: '当前还没有档案，请先新增档案',
    createProfile: '新增档案',
    previous: '上一步',
    interpreting: '解析中...',
    start: '开始解析',
    questionsRequired: '请先完成三问',
    agentRequired: '请选择智能体',
    profileRequired: '请选择档案',
    agent1Name: '云衡先生',
    agent1Title: '四柱命理顾问',
    agent1Summary: '从命盘脉络中，看见人生节奏。',
    agent1Tag1: '命盘脉络', agent1Tag2: '流年节奏', agent1Tag3: '人生方向',
    agent2Name: '梦枝',
    agent2Title: '梦境释义师',
    agent2Summary: '拆解梦境线索，读懂潜意识提醒。',
    agent2Tag1: '梦境拆解', agent2Tag2: '潜意识线索', agent2Tag3: '人生方向',
    agent3Name: '乾策先生',
    agent3Title: '事业财运参谋',
    agent3Summary: '理清事业节奏，看见风险与机会。',
    agent3Tag1: '事业节奏', agent3Tag2: '财务习惯', agent3Tag3: '风险提醒'
  },
  profile: {
    listTitle: '我的档案',
    searchPlaceholder: '请输入昵称搜索',
    default: '默认',
    noProfiles: '暂无档案',
    create: '新建档案',
    birthplace: '出生地点：{value}',
    solarDate: '公历：{value}',
    lunarDate: '农历：{value}',
    trueSolarTime: '真太阳时（公历）：{value}',
    calculating: '计算中',
    deleteTitle: '删除档案',
    deleteConfirm: '确认删除该档案吗？',
    deleteSuccess: '删除成功',
    editTitle: '编辑档案',
    createTitle: '新建档案',
    name: '姓名',
    namePlaceholder: '请输入姓名',
    gender: '性别',
    birthDate: '出生日期',
    birthDatePlaceholder: '请选择出生日期',
    currentCalendar: '当前历法',
    correspondingSolar: '对应公历',
    correspondingLunar: '对应农历',
    pendingConversion: '待换算',
    birthTime: '出生时间',
    birthTimePlaceholder: '请输入出生时间，可直接输入6位数',
    birthAddress: '出生地点',
    birthAddressPlaceholder: '请输入出生地点',
    setDefault: '设为默认档案',
    year: '{value}年',
    month: '{value}月',
    day: '{value}日',
    genderRequired: '请选择性别',
    calendarRequired: '请选择历法',
    conversionIncomplete: '出生日期换算未完成，请重新选择出生日期',
    timeInvalid: '出生时间格式需为 HH:mm 或 HH:mm:ss',
    saved: '档案已保存'
  },
  account: {
    title: '个人中心',
    member: '会员',
    notLoggedIn: '未登录',
    profiles: '档案列表',
    results: '结果列表',
    logout: '退出账号',
    logoutMessage: '确认退出当前账号吗？',
    logoutSuccess: '已退出登录'
  },
  results: {
    title: '结果列表',
    advisor: '智能顾问',
    consultation: '咨询记录',
    empty: '暂无结果记录',
    clear: '清空',
    today: '今天',
    week: '近 7 天',
    earlier: '更早',
    generating: '解读生成中，请稍后查看',
    date: '{month}月{day}日',
    processing: '生成中',
    failed: '生成失败',
    failedNotice: '该结果生成失败，请等待重试',
    pendingNotice: '该结果尚未完成，请稍后查看',
    clearEmpty: '当前暂无可清空的结果',
    clearTitle: '清空结果',
    clearConfirm: '确认清空当前账号下的全部结果记录吗？',
    clearSuccess: '结果已清空'
  },
  resultDetail: {
    title: '解读结果',
    questionSummary: '问题摘要',
    consultTarget: '咨询对象',
    viewProfile: '查看档案',
    divinationResult: '起卦结果',
    selection: '本次选择：{value}',
    hexagramInterpretation: '卦象解读',
    primaryHexagram: '本卦',
    changedHexagram: '变卦',
    changedLine: '变爻：{value}',
    interpretationResult: '解读结果',
    riskNotice: '关键提醒',
    actionAdvice: '行动建议',
    createPoster: '生成结果海报',
    deleteRecord: '删除本条记录',
    share: '分享结果',
    pending: '待生成',
    completed: '已完成',
    processing: '处理中',
    question1Missing: '未填写问题摘要',
    question2Missing: '未填写第 2 问答案',
    question3Missing: '未填写第 3 问答案',
    profileMissing: '未关联档案',
    step: '第{index}次 {value}',
    undetermined: '待定',
    primaryPending: '本卦待生成',
    summaryMissing: '暂未获取卦象摘要',
    changedPending: '变卦待生成',
    changedSummaryMissing: '暂未获取变卦摘要',
    notReturned: '未返回',
    conclusionMissing: '暂无结论',
    summaryLabel: '总结信息',
    summaryTextMissing: '暂无总结信息',
    analysisMissing: '暂无分析内容',
    riskMissing: '暂无风险提示',
    adviceMissing: '暂无行动建议',
    fortune: '卦象吉凶',
    generatedByFull: '由 {name}·{title} 生成 | {summary}',
    generatedByTitle: '由 {name}·{title} 生成',
    generatedByName: '由 {name} 生成',
    generatedByAdvisor: '由本次智能顾问生成',
    recordRequired: '请先选择一条解读记录',
    generationFailed: '该结果生成失败，请返回重新发起解析',
    generationPending: '该结果尚未完成，请稍后在结果列表查看',
    noRelatedProfile: '当前结果未关联档案',
    shareParameterMissing: '缺少分享参数',
    posterParameterMissing: '缺少海报生成参数',
    posterOpening: '海报已生成，正在进入分享页',
    posterCreated: '结果海报已生成',
    deleteParameterMissing: '当前记录缺少删除参数',
    deleteTitle: '删除记录',
    deleteConfirm: '确认删除这条解读记录吗？'
  },
  share: {
    primary: '[本卦]',
    changed: '[变卦]',
    slogan: '我测得很准，快来试一试！',
    scan: '扫码查看你的专属卦象',
    manualDownload: '手动下载',
    advisor: '智能顾问',
    summaryMissing: '暂无卦象摘要',
    pending: '待生成',
    summaryTextMissing: '暂无总结信息',
    generating: '正在生成海报...',
    systemSave: '请在系统分享面板中选择“存储图像”',
    downloadHelp: '下载中，若未成功保存海报或生成结果有误，请手动下载或更换浏览器重试',
    downloadStarted: '海报已开始下载',
    generationFailed: '海报生成失败，请稍后重试',
    posterName: '解读海报',
    defaultFileName: '东方玄学-解读海报'
  },
  tutorial: {
    title: '使用指南',
    one: '【壹】',
    oneTitle: '静心凝神 · 掌中开卦',
    oneLine1: '将八卦盘平放于左手掌心，盘面朝南。',
    oneLine2: '微闭双目，呼吸放缓，摒弃杂念。',
    oneLine3: '心中默念您所祈之事，待思绪全然凝聚后，准备起卦。',
    two: '【贰】',
    twoTitle: '轻拨太极 · 以观天机',
    twoIntro: '用指尖轻轻拨动八卦盘中央的太极图案。待盘面完全静止后，观察红珠最终停止的位置：',
    qianRule: '若停于中间水平线上方，记为“',
    kunRule: '若停于中间水平线下方，记为“',
    repeat: '重复此动作三次，依次得出结果。',
    three: '【叁】',
    threeTitle: '录入卦象 · 启卦得爻',
    threePrefix: '根据刚才三次转动的结果，依次',
    click: '点击',
    threeBody: '页面中央金色按钮上的“乾”或“坤”进行录入。下方对应的太极图标会自动记录您的每一次选择（如需修改，可直接点击太极图标重选）。',
    threeConfirm: '确认下方三爻无误后，点击“',
    start: '起卦',
    threeEnd: '”按钮，即可获得专属卦象解读。'
  },
  bazi: {
    profileInfo: '档案信息',
    heavenlyStems: '天干',
    earthlyBranches: '地支',
    yearPillar: '年柱',
    monthPillar: '月柱',
    dayPillar: '日柱',
    hourPillar: '时柱',
    profileRequired: '请先选择档案',
    row: {
      naYin: '纳音',
      xingYun: '星运',
      ziZuo: '自坐',
      kongWang: '空亡',
      shenSha: '神煞'
    },
    term: {
      tenGod: {
        biJian: '比肩', jieCai: '劫财', shiShen: '食神', shangGuan: '伤官', pianYin: '偏印',
        zhengYin: '正印', pianCai: '偏财', zhengCai: '正财', qiSha: '七杀', zhengGuan: '正官'
      },
      stage: {
        changSheng: '长生', muYu: '沐浴', guanDai: '冠带', linGuan: '临官', diWang: '帝旺', shuai: '衰',
        bing: '病', si: '死', mu: '墓', jue: '绝', tai: '胎', yang: '养'
      },
      shenSha: {
        tianYiGuiRen: '天乙贵人', taiJiGuiRen: '太极贵人', guoYinGuiRen: '国印贵人', fuXingGuiRen: '福星贵人',
        tianDeGuiRen: '天德贵人', yueDeGuiRen: '月德贵人', tianYi: '天医', taoHua: '桃花', yiMa: '驿马',
        huaGai: '华盖', jiangXing: '将星', wangShen: '亡神', jieSha: '劫煞', zaiSha: '灾煞',
        tianLuoDiWang: '天罗地网', kuiGang: '魁罡', yinChaYangCuo: '阴差阳错'
      },
      naYin: {
        haiZhongJin: '海中金', luZhongHuo: '炉中火', daLinMu: '大林木', luPangTu: '路旁土', jianFengJin: '剑锋金',
        shanTouHuo: '山头火', jianXiaShui: '涧下水', chengTouTu: '城头土', baiLaJin: '白蜡金', yangLiuMu: '杨柳木',
        quanZhongShui: '泉中水', wuShangTu: '屋上土', piLiHuo: '霹雳火', songBaiMu: '松柏木', changLiuShui: '长流水',
        shaZhongJin: '砂中金', shanXiaHuo: '山下火', pingDiMu: '平地木', biShangTu: '壁上土', jinBoJin: '金箔金',
        daXiShui: '大溪水', shaZhongTu: '沙中土', tianHeShui: '天河水', tianShangHuo: '天上火', shiLiuMu: '石榴木',
        daHaiShui: '大海水', fuDengHuo: '覆灯火', chaiChuanJin: '钗钏金', daYiTu: '大驿土', sangZheMu: '桑柘木'
      }
    }
  },
  showcase: {
    chat: '聊一聊',
    bazi: {
      title: '四柱命理顾问', feature1: '命盘速览', feature2: '流年提醒', name: '云衡先生',
      summary: '从命盘脉络中，看见人生节奏。', tag1: '命盘脉络', tag2: '流年节奏', tag3: '人生方向'
    },
    dream: {
      title: '梦境释义师', feature1: '梦境复盘', feature2: '线索提取', name: '梦枝',
      summary: '拆解梦境线索，读懂潜意识提醒。', tag1: '梦境拆解', tag2: '潜意识线索', tag3: '人生方向'
    },
    career: {
      title: '事业财运参谋', feature1: '财路分析', feature2: '决策提示', name: '乾策先生',
      summary: '理清节奏，看见风险，也看见机会。', tag1: '事业节奏', tag2: '财务习惯', tag3: '风险提醒'
    },
    sign: {
      title: '灵签问事引导', feature1: '今日一签', feature2: '问事指引', name: '签语',
      summary: '抽一支签，为眼前的选择留下一点提示。', tag1: '日常问签', tag2: '行动提示', tag3: '取舍参考'
    },
    relief: {
      title: '困局梳理伙伴', feature1: '解忧对谈', feature2: '行动清单', name: '知止',
      summary: '把纷乱放下，找到可以迈出的下一步。', tag1: '关系分辨', tag2: '选择辅助', tag3: '下一步建议'
    }
  },
  admin: {
    eyebrow: '内部管理', title: '激活码管理', description: '支持生成激活码、查看使用状态，并导出当前筛选结果。',
    passwordTitle: '输入管理密码', passwordDescription: '仅手动访问链接的内部管理页可用，验证成功后才可查看数据与生成激活码。',
    password: '管理密码', passwordPlaceholder: '请输入管理密码', verifying: '验证中...', enter: '进入管理页',
    generateTitle: '生成激活码', generateDescription: '激活码为 6 位随机字母数字组合，可按批次导出为 Excel。',
    latestBatch: '最近批次：{batch}，共 {quantity} 个。', quantity: '生成数量', channel: '渠道标识', channelPlaceholder: '可选，默认 DEFAULT',
    generating: '生成中...', generateDownload: '生成并下载 Excel', activationList: '激活码列表', allStatuses: '全部状态',
    unused: '未使用', used: '已激活', expired: '已过期', pageSize: '每页 {size} 条', refreshing: '刷新中...', refresh: '刷新列表',
    export: '导出当前列表', activationCode: '激活码', status: '状态', batchNo: '批次号', userId: '用户 ID', contact: '手机号 / 邮箱',
    activatedAt: '激活时间', createdAt: '生成时间', previous: '上一页', next: '下一页', page: '第 {page} / {pages} 页，共 {total} 条',
    tokenList: 'Token 用量列表', action: '本次动作', model: '模型', inputToken: '输入 Token', outputToken: '输出 Token', totalToken: '总 Token',
    recordedAt: '记录时间', inputOutput: '输入 / 输出', passwordRequired: '请输入管理密码', verified: '验证通过', quantityInvalid: '请输入正确的生成数量',
    generated: '激活码已生成并开始下载', excelMissing: '接口未返回 Excel 数据', exportEmpty: '当前没有可导出的数据', exported: '当前列表已导出'
  }
};

const zhTW = {
  app: {
    title: '東方玄學'
  },
  language: {
    label: '語言',
    simplifiedChinese: '简体中文',
    traditionalChinese: '繁體中文',
    english: 'English'
  },
  common: {
    requestFailed: '請求失敗',
    networkError: '網路錯誤',
    sessionExpired: '登入狀態已失效，請重新登入',
    confirm: '確定',
    cancel: '取消',
    back: '返回',
    loading: '載入中...',
    noData: '暫無資料',
    save: '儲存',
    saving: '儲存中...',
    delete: '刪除',
    edit: '編輯',
    view: '查看',
    previous: '上一步',
    next: '下一步',
    male: '男',
    female: '女',
    solarCalendar: '國曆',
    lunarCalendar: '農曆'
  },
  loading: {
    tagline: '東方命理 + 智慧指引',
    entering: '正在進入{dots}',
    progress: '載入中 {progress}%'
  },
  activation: {
    login: '登入',
    title: '請完成啟用',
    description: '目前帳號尚未啟用，完成啟用後才可繼續使用',
    loggedIn: '帳號已登入，繼續完成啟用',
    phoneHint: '目前手機號碼已自動註冊，請先完成首次啟用',
    emailHint: '目前電子郵件已自動註冊，請先完成首次啟用',
    accountHint: '目前帳號尚未啟用，請先完成首次啟用',
    placeholder: '請輸入啟用碼',
    activating: '啟用中...',
    activate: '啟用並繼續',
    backToLogin: '返回登入',
    required: '請輸入啟用碼',
    loginInvalid: '登入狀態異常，請重新登入',
    success: '啟用成功'
  },
  home: {
    slogan: '先起卦，後提問，再解讀',
    intro: '透過三次乾坤選擇，開啟本次卜卦諮詢',
    account: '帳號',
    profiles: '檔案',
    results: '結果',
    divinationFirst: '先起卦',
    calmSelection: '靜心選擇',
    questionsSecond: '後提問',
    focusQuestion: '聚焦所問',
    interpretationThird: '再解讀',
    receiveGuidance: '獲得指引',
    start: '開始起卦',
    submitted: '已提交解析請求，請稍後在結果清單查看'
  },
  divination: {
    title: '起卦',
    guide: '使用指南',
    instruction: '請集中精神，點選上方乾坤選擇，然後點選起卦',
    completed: '已完成 {count}/3',
    starting: '起卦中...',
    start: '起卦',
    qian: '乾',
    kun: '坤',
    selection: '第{index}次選擇：{value}',
    firstSelection: '請先完成第 1 次選擇',
    allSelected: '已完成 3 次選擇，可直接起卦',
    incomplete: '請先完成 3 次乾坤選擇'
  },
  hexagram: {
    title: '卦象解讀',
    continue: '繼續解讀',
    result: '卦象結果',
    generated: '本次卦象已產生，可繼續進入三問並開始解析。',
    movingLine: '動爻'
  },
  login: {
    title: '登入',
    welcome: '歡迎回來',
    subtitle: '請登入以繼續使用',
    mobile: '手機號碼',
    email: '電子郵件',
    mobilePlaceholder: '請輸入手機號碼',
    emailPlaceholder: '請輸入電子郵件地址',
    codePlaceholder: '請輸入驗證碼',
    getCode: '取得驗證碼',
    agreementPrefix: '我已閱讀並同意',
    userAgreement: '使用者協議',
    and: '和',
    privacyPolicy: '隱私權政策',
    signingIn: '登入中...',
    submit: '登入 / 註冊',
    mobileAutoRegister: '未註冊帳號將自動註冊',
    mainlandOnly: '僅支援中國大陸手機號碼',
    emailAutoRegister: '未註冊電子郵件將自動註冊',
    mobileInvalid: '請輸入正確的手機號碼',
    emailInvalid: '請輸入正確的電子郵件地址',
    codeSent: '驗證碼已傳送',
    agreementRequired: '請先閱讀並同意協議',
    codeRequired: '請輸入驗證碼',
    registerSuccess: '註冊並登入成功',
    success: '登入成功'
  },
  question: {
    pageTitle: '問題資訊',
    title: '填寫問題',
    subtitle: '請依序回答以下問題',
    next: '下一步',
    previous: '上一步',
    reveal: '揭曉天機',
    first: '1. 你這次想問的是什麼事？',
    second: '2. 這件事急不急？',
    third: '3. 是你自己的事嗎？若不是，對方是你什麼人？',
    firstPlaceholder: '請詳細描述您的問題...',
    secondPlaceholder: '請描述事情的緊急程度...',
    thirdPlaceholder: '請描述相關關係...',
    divinationRequired: '請先完成起卦',
    contentRequired: '請先填寫內容',
    tooLong: '目前問題最多輸入{max}字'
  },
  consultConfig: {
    title: '解析設定',
    selectAgent: '選擇智能體',
    selectProfile: '選擇檔案',
    dateMissing: '日期待補充',
    addressMissing: '出生地點待補充',
    selected: '已選擇',
    select: '選擇',
    noProfiles: '目前還沒有檔案，請先新增檔案',
    createProfile: '新增檔案',
    previous: '上一步',
    interpreting: '解析中...',
    start: '開始解析',
    questionsRequired: '請先完成三問',
    agentRequired: '請選擇智能體',
    profileRequired: '請選擇檔案',
    agent1Name: '雲衡先生',
    agent1Title: '四柱命理顧問',
    agent1Summary: '從命盤脈絡中，看見人生節奏。',
    agent1Tag1: '命盤脈絡', agent1Tag2: '流年節奏', agent1Tag3: '人生方向',
    agent2Name: '夢枝',
    agent2Title: '夢境釋義師',
    agent2Summary: '拆解夢境線索，讀懂潛意識提醒。',
    agent2Tag1: '夢境拆解', agent2Tag2: '潛意識線索', agent2Tag3: '人生方向',
    agent3Name: '乾策先生',
    agent3Title: '事業財運參謀',
    agent3Summary: '理清事業節奏，看見風險與機會。',
    agent3Tag1: '事業節奏', agent3Tag2: '財務習慣', agent3Tag3: '風險提醒'
  },
  profile: {
    listTitle: '我的檔案',
    searchPlaceholder: '請輸入暱稱搜尋',
    default: '預設',
    noProfiles: '暫無檔案',
    create: '新增檔案',
    birthplace: '出生地點：{value}',
    solarDate: '國曆：{value}',
    lunarDate: '農曆：{value}',
    trueSolarTime: '真太陽時（國曆）：{value}',
    calculating: '計算中',
    deleteTitle: '刪除檔案',
    deleteConfirm: '確定刪除該檔案嗎？',
    deleteSuccess: '刪除成功',
    editTitle: '編輯檔案',
    createTitle: '新增檔案',
    name: '姓名',
    namePlaceholder: '請輸入姓名',
    gender: '性別',
    birthDate: '出生日期',
    birthDatePlaceholder: '請選擇出生日期',
    currentCalendar: '目前曆法',
    correspondingSolar: '對應國曆',
    correspondingLunar: '對應農曆',
    pendingConversion: '待換算',
    birthTime: '出生時間',
    birthTimePlaceholder: '請輸入出生時間，可直接輸入6位數',
    birthAddress: '出生地點',
    birthAddressPlaceholder: '請輸入出生地點',
    setDefault: '設為預設檔案',
    year: '{value}年',
    month: '{value}月',
    day: '{value}日',
    genderRequired: '請選擇性別',
    calendarRequired: '請選擇曆法',
    conversionIncomplete: '出生日期換算尚未完成，請重新選擇出生日期',
    timeInvalid: '出生時間格式須為 HH:mm 或 HH:mm:ss',
    saved: '檔案已儲存'
  },
  account: {
    title: '個人中心',
    member: '會員',
    notLoggedIn: '未登入',
    profiles: '檔案清單',
    results: '結果清單',
    logout: '登出帳號',
    logoutMessage: '確定登出目前帳號嗎？',
    logoutSuccess: '已登出'
  },
  results: {
    title: '結果清單',
    advisor: '智能顧問',
    consultation: '諮詢記錄',
    empty: '暫無結果記錄',
    clear: '清空',
    today: '今天',
    week: '近 7 天',
    earlier: '更早',
    generating: '解讀產生中，請稍後查看',
    date: '{month}月{day}日',
    processing: '產生中',
    failed: '產生失敗',
    failedNotice: '該結果產生失敗，請等待重試',
    pendingNotice: '該結果尚未完成，請稍後查看',
    clearEmpty: '目前暫無可清空的結果',
    clearTitle: '清空結果',
    clearConfirm: '確定清空目前帳號下的全部結果記錄嗎？',
    clearSuccess: '結果已清空'
  },
  resultDetail: {
    title: '解讀結果',
    questionSummary: '問題摘要',
    consultTarget: '諮詢對象',
    viewProfile: '查看檔案',
    divinationResult: '起卦結果',
    selection: '本次選擇：{value}',
    hexagramInterpretation: '卦象解讀',
    primaryHexagram: '本卦',
    changedHexagram: '變卦',
    changedLine: '變爻：{value}',
    interpretationResult: '解讀結果',
    riskNotice: '關鍵提醒',
    actionAdvice: '行動建議',
    createPoster: '產生結果海報',
    deleteRecord: '刪除本筆記錄',
    share: '分享結果',
    pending: '待產生',
    completed: '已完成',
    processing: '處理中',
    question1Missing: '未填寫問題摘要',
    question2Missing: '未填寫第 2 問答案',
    question3Missing: '未填寫第 3 問答案',
    profileMissing: '未關聯檔案',
    step: '第{index}次 {value}',
    undetermined: '待定',
    primaryPending: '本卦待產生',
    summaryMissing: '暫未取得卦象摘要',
    changedPending: '變卦待產生',
    changedSummaryMissing: '暫未取得變卦摘要',
    notReturned: '未回傳',
    conclusionMissing: '暫無結論',
    summaryLabel: '總結資訊',
    summaryTextMissing: '暫無總結資訊',
    analysisMissing: '暫無分析內容',
    riskMissing: '暫無風險提示',
    adviceMissing: '暫無行動建議',
    fortune: '卦象吉凶',
    generatedByFull: '由 {name}·{title} 產生 | {summary}',
    generatedByTitle: '由 {name}·{title} 產生',
    generatedByName: '由 {name} 產生',
    generatedByAdvisor: '由本次智能顧問產生',
    recordRequired: '請先選擇一筆解讀記錄',
    generationFailed: '該結果產生失敗，請返回重新發起解析',
    generationPending: '該結果尚未完成，請稍後在結果清單查看',
    noRelatedProfile: '目前結果未關聯檔案',
    shareParameterMissing: '缺少分享參數',
    posterParameterMissing: '缺少海報產生參數',
    posterOpening: '海報已產生，正在進入分享頁',
    posterCreated: '結果海報已產生',
    deleteParameterMissing: '目前記錄缺少刪除參數',
    deleteTitle: '刪除記錄',
    deleteConfirm: '確定刪除這筆解讀記錄嗎？'
  },
  share: {
    primary: '[本卦]',
    changed: '[變卦]',
    slogan: '我測得很準，快來試一試！',
    scan: '掃碼查看你的專屬卦象',
    manualDownload: '手動下載',
    advisor: '智能顧問',
    summaryMissing: '暫無卦象摘要',
    pending: '待產生',
    summaryTextMissing: '暫無總結資訊',
    generating: '正在產生海報...',
    systemSave: '請在系統分享面板中選擇「儲存影像」',
    downloadHelp: '下載中，若未成功儲存海報或產生結果有誤，請手動下載或更換瀏覽器重試',
    downloadStarted: '海報已開始下載',
    generationFailed: '海報產生失敗，請稍後重試',
    posterName: '解讀海報',
    defaultFileName: '東方玄學-解讀海報'
  },
  tutorial: {
    title: '使用指南',
    one: '【壹】',
    oneTitle: '靜心凝神 · 掌中開卦',
    oneLine1: '將八卦盤平放於左手掌心，盤面朝南。',
    oneLine2: '微閉雙目，呼吸放緩，摒棄雜念。',
    oneLine3: '心中默念您所祈之事，待思緒全然凝聚後，準備起卦。',
    two: '【貳】',
    twoTitle: '輕撥太極 · 以觀天機',
    twoIntro: '用指尖輕輕撥動八卦盤中央的太極圖案。待盤面完全靜止後，觀察紅珠最終停止的位置：',
    qianRule: '若停於中間水平線上方，記為「',
    kunRule: '若停於中間水平線下方，記為「',
    repeat: '重複此動作三次，依序得出結果。',
    three: '【參】',
    threeTitle: '錄入卦象 · 啟卦得爻',
    threePrefix: '根據剛才三次轉動的結果，依序',
    click: '點選',
    threeBody: '頁面中央金色按鈕上的「乾」或「坤」進行錄入。下方對應的太極圖示會自動記錄您的每一次選擇（如需修改，可直接點選太極圖示重選）。',
    threeConfirm: '確認下方三爻無誤後，點選「',
    start: '起卦',
    threeEnd: '」按鈕，即可獲得專屬卦象解讀。'
  },
  bazi: {
    profileInfo: '檔案資訊',
    heavenlyStems: '天干',
    earthlyBranches: '地支',
    yearPillar: '年柱',
    monthPillar: '月柱',
    dayPillar: '日柱',
    hourPillar: '時柱',
    profileRequired: '請先選擇檔案',
    row: {
      naYin: '納音',
      xingYun: '星運',
      ziZuo: '自坐',
      kongWang: '空亡',
      shenSha: '神煞'
    },
    term: {
      tenGod: {
        biJian: '比肩', jieCai: '劫財', shiShen: '食神', shangGuan: '傷官', pianYin: '偏印',
        zhengYin: '正印', pianCai: '偏財', zhengCai: '正財', qiSha: '七殺', zhengGuan: '正官'
      },
      stage: {
        changSheng: '長生', muYu: '沐浴', guanDai: '冠帶', linGuan: '臨官', diWang: '帝旺', shuai: '衰',
        bing: '病', si: '死', mu: '墓', jue: '絕', tai: '胎', yang: '養'
      },
      shenSha: {
        tianYiGuiRen: '天乙貴人', taiJiGuiRen: '太極貴人', guoYinGuiRen: '國印貴人', fuXingGuiRen: '福星貴人',
        tianDeGuiRen: '天德貴人', yueDeGuiRen: '月德貴人', tianYi: '天醫', taoHua: '桃花', yiMa: '驛馬',
        huaGai: '華蓋', jiangXing: '將星', wangShen: '亡神', jieSha: '劫煞', zaiSha: '災煞',
        tianLuoDiWang: '天羅地網', kuiGang: '魁罡', yinChaYangCuo: '陰差陽錯'
      },
      naYin: {
        haiZhongJin: '海中金', luZhongHuo: '爐中火', daLinMu: '大林木', luPangTu: '路旁土', jianFengJin: '劍鋒金',
        shanTouHuo: '山頭火', jianXiaShui: '澗下水', chengTouTu: '城頭土', baiLaJin: '白蠟金', yangLiuMu: '楊柳木',
        quanZhongShui: '泉中水', wuShangTu: '屋上土', piLiHuo: '霹靂火', songBaiMu: '松柏木', changLiuShui: '長流水',
        shaZhongJin: '砂中金', shanXiaHuo: '山下火', pingDiMu: '平地木', biShangTu: '壁上土', jinBoJin: '金箔金',
        daXiShui: '大溪水', shaZhongTu: '沙中土', tianHeShui: '天河水', tianShangHuo: '天上火', shiLiuMu: '石榴木',
        daHaiShui: '大海水', fuDengHuo: '覆燈火', chaiChuanJin: '釵釧金', daYiTu: '大驛土', sangZheMu: '桑柘木'
      }
    }
  },
  showcase: {
    chat: '聊一聊',
    bazi: {
      title: '四柱命理顧問', feature1: '命盤速覽', feature2: '流年提醒', name: '雲衡先生',
      summary: '從命盤脈絡中，看見人生節奏。', tag1: '命盤脈絡', tag2: '流年節奏', tag3: '人生方向'
    },
    dream: {
      title: '夢境釋義師', feature1: '夢境複盤', feature2: '線索提取', name: '夢枝',
      summary: '拆解夢境線索，讀懂潛意識提醒。', tag1: '夢境拆解', tag2: '潛意識線索', tag3: '人生方向'
    },
    career: {
      title: '事業財運參謀', feature1: '財路分析', feature2: '決策提示', name: '乾策先生',
      summary: '理清節奏，看見風險，也看見機會。', tag1: '事業節奏', tag2: '財務習慣', tag3: '風險提醒'
    },
    sign: {
      title: '靈籤問事引導', feature1: '今日一籤', feature2: '問事指引', name: '籤語',
      summary: '抽一支籤，為眼前的選擇留下一點提示。', tag1: '日常問籤', tag2: '行動提示', tag3: '取捨參考'
    },
    relief: {
      title: '困局梳理夥伴', feature1: '解憂對談', feature2: '行動清單', name: '知止',
      summary: '把紛亂放下，找到可以邁出的下一步。', tag1: '關係分辨', tag2: '選擇輔助', tag3: '下一步建議'
    }
  },
  admin: {
    eyebrow: '內部管理', title: '啟用碼管理', description: '支援產生啟用碼、查看使用狀態，並匯出目前篩選結果。',
    passwordTitle: '輸入管理密碼', passwordDescription: '僅手動存取連結的內部管理頁可用，驗證成功後才可查看資料與產生啟用碼。',
    password: '管理密碼', passwordPlaceholder: '請輸入管理密碼', verifying: '驗證中...', enter: '進入管理頁',
    generateTitle: '產生啟用碼', generateDescription: '啟用碼為 6 位隨機英數組合，可按批次匯出為 Excel。',
    latestBatch: '最近批次：{batch}，共 {quantity} 個。', quantity: '產生數量', channel: '渠道標識', channelPlaceholder: '選填，預設 DEFAULT',
    generating: '產生中...', generateDownload: '產生並下載 Excel', activationList: '啟用碼清單', allStatuses: '全部狀態',
    unused: '未使用', used: '已啟用', expired: '已過期', pageSize: '每頁 {size} 筆', refreshing: '重新整理中...', refresh: '重新整理清單',
    export: '匯出目前清單', activationCode: '啟用碼', status: '狀態', batchNo: '批次號', userId: '使用者 ID', contact: '手機號碼 / 電子郵件',
    activatedAt: '啟用時間', createdAt: '產生時間', previous: '上一頁', next: '下一頁', page: '第 {page} / {pages} 頁，共 {total} 筆',
    tokenList: 'Token 用量清單', action: '本次動作', model: '模型', inputToken: '輸入 Token', outputToken: '輸出 Token', totalToken: '總 Token',
    recordedAt: '記錄時間', inputOutput: '輸入 / 輸出', passwordRequired: '請輸入管理密碼', verified: '驗證通過', quantityInvalid: '請輸入正確的產生數量',
    generated: '啟用碼已產生並開始下載', excelMissing: '介面未回傳 Excel 資料', exportEmpty: '目前沒有可匯出的資料', exported: '目前清單已匯出'
  }
};

const enUS = {
  app: {
    title: 'Eastern Metaphysics'
  },
  language: {
    label: 'Language',
    simplifiedChinese: '简体中文',
    traditionalChinese: '繁體中文',
    english: 'English'
  },
  common: {
    requestFailed: 'Request failed',
    networkError: 'Network error',
    sessionExpired: 'Your session has expired. Please sign in again',
    confirm: 'Confirm',
    cancel: 'Cancel',
    back: 'Back',
    loading: 'Loading...',
    noData: 'No data',
    save: 'Save',
    saving: 'Saving...',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    previous: 'Previous',
    next: 'Next',
    male: 'Male',
    female: 'Female',
    solarCalendar: 'Gregorian',
    lunarCalendar: 'Lunar'
  },
  loading: {
    tagline: 'Eastern Destiny · Thoughtful Guidance',
    entering: 'Entering{dots}',
    progress: 'Loading {progress}%'
  },
  activation: {
    login: 'Sign in',
    title: 'Activate your account',
    description: 'Activate this account before continuing',
    loggedIn: 'You are signed in. Complete activation to continue',
    phoneHint: 'Your phone number has been registered. Complete activation first',
    emailHint: 'Your email has been registered. Complete activation first',
    accountHint: 'This account is not active yet. Complete activation first',
    placeholder: 'Enter activation code',
    activating: 'Activating...',
    activate: 'Activate and continue',
    backToLogin: 'Back to sign in',
    required: 'Enter an activation code',
    loginInvalid: 'Your session is invalid. Please sign in again',
    success: 'Account activated'
  },
  home: {
    slogan: 'Cast a hexagram, ask, then interpret',
    intro: 'Make three Qian or Kun choices to begin your consultation',
    account: 'Account',
    profiles: 'Profiles',
    results: 'Results',
    divinationFirst: 'Cast first',
    calmSelection: 'Choose calmly',
    questionsSecond: 'Ask next',
    focusQuestion: 'Focus your question',
    interpretationThird: 'Interpret',
    receiveGuidance: 'Receive guidance',
    start: 'Start divination',
    submitted: 'Your interpretation request was submitted. Check Results shortly'
  },
  divination: {
    title: 'Divination',
    guide: 'Guide',
    instruction: 'Focus, choose Qian or Kun three times, then cast',
    completed: '{count}/3 completed',
    starting: 'Casting...',
    start: 'Cast hexagram',
    qian: 'Qian',
    kun: 'Kun',
    selection: 'Choice {index}: {value}',
    firstSelection: 'Complete choice 1 first',
    allSelected: 'All 3 choices are complete. You can cast the hexagram now',
    incomplete: 'Complete all 3 Qian or Kun choices first'
  },
  hexagram: {
    title: 'Hexagram interpretation',
    continue: 'Continue',
    result: 'Hexagram result',
    generated: 'Your hexagram is ready. Continue to the three questions for interpretation.',
    movingLine: 'Changing line'
  },
  login: {
    title: 'Sign in',
    welcome: 'Welcome back',
    subtitle: 'Sign in to continue',
    mobile: 'Phone',
    email: 'Email',
    mobilePlaceholder: 'Phone number',
    emailPlaceholder: 'Email address',
    codePlaceholder: 'Verification code',
    getCode: 'Get code',
    agreementPrefix: 'I agree to',
    userAgreement: 'Terms',
    and: '&',
    privacyPolicy: 'Privacy',
    signingIn: 'Signing in...',
    submit: 'Continue',
    mobileAutoRegister: 'New numbers auto-register',
    mainlandOnly: 'Mainland China only',
    emailAutoRegister: 'New emails auto-register',
    mobileInvalid: 'Enter a valid phone number',
    emailInvalid: 'Enter a valid email address',
    codeSent: 'Verification code sent',
    agreementRequired: 'Read and accept the agreements first',
    codeRequired: 'Enter the verification code',
    registerSuccess: 'Registered and signed in',
    success: 'Signed in'
  },
  question: {
    pageTitle: 'Your questions',
    title: 'Describe your concern',
    subtitle: 'Answer the following questions in order',
    next: 'Next',
    previous: 'Previous',
    reveal: 'Reveal guidance',
    first: '1. What would you like to ask about?',
    second: '2. How urgent is it?',
    third: '3. Is this about you? If not, what is your relationship to the person?',
    firstPlaceholder: 'Describe your question in detail...',
    secondPlaceholder: 'Describe how urgent it is...',
    thirdPlaceholder: 'Describe the relationship...',
    divinationRequired: 'Complete the divination first',
    contentRequired: 'Enter an answer first',
    tooLong: 'Each answer can contain up to {max} characters'
  },
  consultConfig: {
    title: 'Interpretation setup',
    selectAgent: 'Choose an advisor',
    selectProfile: 'Choose a profile',
    dateMissing: 'Birth date missing',
    addressMissing: 'Birthplace missing',
    selected: 'Selected',
    select: 'Select',
    noProfiles: 'No profiles yet. Create one first',
    createProfile: 'Create profile',
    previous: 'Previous',
    interpreting: 'Starting...',
    start: 'Start interpretation',
    questionsRequired: 'Complete all three questions first',
    agentRequired: 'Choose an advisor',
    profileRequired: 'Choose a profile',
    agent1Name: 'Master Yunheng',
    agent1Title: 'Four Pillars Advisor',
    agent1Summary: 'See the rhythms of life through the structure of your chart.',
    agent1Tag1: 'Chart patterns', agent1Tag2: 'Annual cycles', agent1Tag3: 'Life direction',
    agent2Name: 'Mengzhi',
    agent2Title: 'Dream Interpreter',
    agent2Summary: 'Unpack dream symbols and understand subconscious signals.',
    agent2Tag1: 'Dream analysis', agent2Tag2: 'Subconscious clues', agent2Tag3: 'Life direction',
    agent3Name: 'Master Qiance',
    agent3Title: 'Career and Wealth Advisor',
    agent3Summary: 'Clarify career momentum and recognize risks and opportunities.',
    agent3Tag1: 'Career momentum', agent3Tag2: 'Financial habits', agent3Tag3: 'Risk alerts'
  },
  profile: {
    listTitle: 'My profiles',
    searchPlaceholder: 'Search by name',
    default: 'Default',
    noProfiles: 'No profiles',
    create: 'Create profile',
    birthplace: 'Birthplace: {value}',
    solarDate: 'Gregorian: {value}',
    lunarDate: 'Lunar: {value}',
    trueSolarTime: 'True solar time (Gregorian): {value}',
    calculating: 'Calculating',
    deleteTitle: 'Delete profile',
    deleteConfirm: 'Delete this profile?',
    deleteSuccess: 'Profile deleted',
    editTitle: 'Edit profile',
    createTitle: 'Create profile',
    name: 'Name',
    namePlaceholder: 'Enter name',
    gender: 'Gender',
    birthDate: 'Birth date',
    birthDatePlaceholder: 'Choose birth date',
    currentCalendar: 'Current calendar',
    correspondingSolar: 'Gregorian equivalent',
    correspondingLunar: 'Lunar equivalent',
    pendingConversion: 'Pending conversion',
    birthTime: 'Birth time',
    birthTimePlaceholder: 'Enter birth time, or enter 6 digits',
    birthAddress: 'Birthplace',
    birthAddressPlaceholder: 'Enter birthplace',
    setDefault: 'Set as default profile',
    year: '{value}',
    month: '{value}',
    day: '{value}',
    genderRequired: 'Choose a gender',
    calendarRequired: 'Choose a calendar',
    conversionIncomplete: 'Date conversion is incomplete. Choose the birth date again',
    timeInvalid: 'Birth time must use HH:mm or HH:mm:ss',
    saved: 'Profile saved'
  },
  account: {
    title: 'Account',
    member: 'Member',
    notLoggedIn: 'Not signed in',
    profiles: 'Profiles',
    results: 'Results',
    logout: 'Sign out',
    logoutMessage: 'Sign out of this account?',
    logoutSuccess: 'Signed out'
  },
  results: {
    title: 'Results',
    advisor: 'Advisor',
    consultation: 'Consultation',
    empty: 'No results',
    clear: 'Clear',
    today: 'Today',
    week: 'Last 7 days',
    earlier: 'Earlier',
    generating: 'Interpretation is being generated. Check again shortly',
    date: '{month}/{day}',
    processing: 'Generating',
    failed: 'Failed',
    failedNotice: 'This result failed to generate and is waiting for a retry',
    pendingNotice: 'This result is not ready yet. Check again shortly',
    clearEmpty: 'There are no results to clear',
    clearTitle: 'Clear results',
    clearConfirm: 'Clear all results for this account?',
    clearSuccess: 'Results cleared'
  },
  resultDetail: {
    title: 'Interpretation',
    questionSummary: 'Question summary',
    consultTarget: 'Profile',
    viewProfile: 'View profile',
    divinationResult: 'Divination result',
    selection: 'Selections: {value}',
    hexagramInterpretation: 'Hexagram interpretation',
    primaryHexagram: 'Primary',
    changedHexagram: 'Changed',
    changedLine: 'Changing line: {value}',
    interpretationResult: 'Interpretation',
    riskNotice: 'Key considerations',
    actionAdvice: 'Recommended actions',
    createPoster: 'Create result poster',
    deleteRecord: 'Delete this record',
    share: 'Share result',
    pending: 'Pending',
    completed: 'Completed',
    processing: 'Processing',
    question1Missing: 'Question summary not provided',
    question2Missing: 'Answer 2 not provided',
    question3Missing: 'Answer 3 not provided',
    profileMissing: 'No profile linked',
    step: 'Choice {index}: {value}',
    undetermined: 'Pending',
    primaryPending: 'Primary hexagram pending',
    summaryMissing: 'Hexagram summary unavailable',
    changedPending: 'Changed hexagram pending',
    changedSummaryMissing: 'Changed hexagram summary unavailable',
    notReturned: 'Unavailable',
    conclusionMissing: 'No conclusion available',
    summaryLabel: 'Summary',
    summaryTextMissing: 'No summary available',
    analysisMissing: 'No interpretation available',
    riskMissing: 'No risk notes available',
    adviceMissing: 'No recommendations available',
    fortune: 'Outlook',
    generatedByFull: 'Generated by {name} · {title} | {summary}',
    generatedByTitle: 'Generated by {name} · {title}',
    generatedByName: 'Generated by {name}',
    generatedByAdvisor: 'Generated by your selected advisor',
    recordRequired: 'Select an interpretation record first',
    generationFailed: 'This result failed to generate. Go back and start another interpretation',
    generationPending: 'This result is not ready. Check the Results page shortly',
    noRelatedProfile: 'No profile is linked to this result',
    shareParameterMissing: 'Sharing information is missing',
    posterParameterMissing: 'Poster information is missing',
    posterOpening: 'Poster created. Opening the share page',
    posterCreated: 'Result poster created',
    deleteParameterMissing: 'The record cannot be deleted because its identifier is missing',
    deleteTitle: 'Delete record',
    deleteConfirm: 'Delete this interpretation record?'
  },
  share: {
    primary: '[Primary]',
    changed: '[Changed]',
    slogan: 'My reading was insightful—try yours!',
    scan: 'Scan to view your personal hexagram',
    manualDownload: 'Download manually',
    advisor: 'Advisor',
    summaryMissing: 'No hexagram summary available',
    pending: 'Pending',
    summaryTextMissing: 'No summary available',
    generating: 'Creating poster...',
    systemSave: 'Choose “Save Image” in the system share menu',
    downloadHelp: 'Downloading. If the poster is not saved correctly, download it manually or try another browser',
    downloadStarted: 'Poster download started',
    generationFailed: 'Could not create the poster. Try again later',
    posterName: 'Interpretation Poster',
    defaultFileName: 'Eastern-Metaphysics-Interpretation'
  },
  tutorial: {
    title: 'Guide',
    one: 'Step 1',
    oneTitle: 'Settle your mind · Hold the compass',
    oneLine1: 'Place the Bagua compass flat in your left palm, facing south.',
    oneLine2: 'Close your eyes gently, slow your breathing, and let distractions go.',
    oneLine3: 'Hold your question in mind. When your thoughts are focused, begin.',
    two: 'Step 2',
    twoTitle: 'Turn the Taiji · Observe the sign',
    twoIntro: 'Gently spin the Taiji at the center of the compass. When it stops, note where the red bead rests:',
    qianRule: 'Above the center line, record “',
    kunRule: 'Below the center line, record “',
    repeat: 'Repeat three times and record each result in order.',
    three: 'Step 3',
    threeTitle: 'Enter the signs · Form the hexagram',
    threePrefix: 'Using the three results,',
    click: 'select',
    threeBody: '“Qian” or “Kun” on the gold button in the center. The Taiji icons below record each choice; select an icon to change it.',
    threeConfirm: 'After confirming all three lines, select “',
    start: 'Cast hexagram',
    threeEnd: '” to receive your interpretation.'
  },
  bazi: {
    profileInfo: 'Profile details',
    heavenlyStems: 'Heavenly Stems',
    earthlyBranches: 'Earthly Branches',
    yearPillar: 'Year',
    monthPillar: 'Month',
    dayPillar: 'Day',
    hourPillar: 'Hour',
    profileRequired: 'Choose a profile first',
    row: {
      naYin: 'Na Yin',
      xingYun: 'Life Stage',
      ziZuo: 'Pillar Stage',
      kongWang: 'Void',
      shenSha: 'Symbolic Stars'
    },
    term: {
      tenGod: {
        biJian: 'Friend', jieCai: 'Rob Wealth', shiShen: 'Eating God', shangGuan: 'Hurting Officer', pianYin: 'Indirect Resource',
        zhengYin: 'Direct Resource', pianCai: 'Indirect Wealth', zhengCai: 'Direct Wealth', qiSha: 'Seven Killings', zhengGuan: 'Direct Officer'
      },
      stage: {
        changSheng: 'Birth', muYu: 'Bath', guanDai: 'Crown Belt', linGuan: 'Officer', diWang: 'Prosperity', shuai: 'Decline',
        bing: 'Sickness', si: 'Death', mu: 'Tomb', jue: 'Extinction', tai: 'Conception', yang: 'Nurture'
      },
      shenSha: {
        tianYiGuiRen: 'Heavenly Nobleman', taiJiGuiRen: 'Taiji Nobleman', guoYinGuiRen: 'State Seal Nobleman', fuXingGuiRen: 'Fortune Star Nobleman',
        tianDeGuiRen: 'Heavenly Virtue Nobleman', yueDeGuiRen: 'Monthly Virtue Nobleman', tianYi: 'Heavenly Doctor', taoHua: 'Peach Blossom', yiMa: 'Traveling Horse',
        huaGai: 'Elegant Canopy', jiangXing: 'General Star', wangShen: 'Lost Spirit', jieSha: 'Robbery Sha', zaiSha: 'Disaster Sha',
        tianLuoDiWang: 'Celestial Net', kuiGang: 'Kui Gang', yinChaYangCuo: 'Yin-Yang Error'
      },
      naYin: {
        haiZhongJin: 'Metal in the Sea', luZhongHuo: 'Fire in the Furnace', daLinMu: 'Forest Wood', luPangTu: 'Roadside Earth', jianFengJin: 'Sword-edge Metal',
        shanTouHuo: 'Mountain-top Fire', jianXiaShui: 'Stream Water', chengTouTu: 'City-wall Earth', baiLaJin: 'White-wax Metal', yangLiuMu: 'Willow Wood',
        quanZhongShui: 'Spring Water', wuShangTu: 'Rooftop Earth', piLiHuo: 'Thunderbolt Fire', songBaiMu: 'Pine and Cypress Wood', changLiuShui: 'Long-flowing Water',
        shaZhongJin: 'Sand Metal', shanXiaHuo: 'Mountain-foot Fire', pingDiMu: 'Level-ground Wood', biShangTu: 'Wall Earth', jinBoJin: 'Gold-leaf Metal',
        daXiShui: 'Great Stream Water', shaZhongTu: 'Sand Earth', tianHeShui: 'Celestial River Water', tianShangHuo: 'Heavenly Fire', shiLiuMu: 'Pomegranate Wood',
        daHaiShui: 'Ocean Water', fuDengHuo: 'Lamp Fire', chaiChuanJin: 'Hairpin Metal', daYiTu: 'Post-station Earth', sangZheMu: 'Mulberry Wood'
      }
    }
  },
  showcase: {
    chat: 'Start a conversation',
    bazi: {
      title: 'Four Pillars Advisor', feature1: 'Chart overview', feature2: 'Annual outlook', name: 'Master Yunheng',
      summary: 'See the rhythms of life through the structure of your chart.', tag1: 'Chart patterns', tag2: 'Annual cycles', tag3: 'Life direction'
    },
    dream: {
      title: 'Dream Interpreter', feature1: 'Dream review', feature2: 'Clue extraction', name: 'Mengzhi',
      summary: 'Unpack dream symbols and understand subconscious signals.', tag1: 'Dream symbols', tag2: 'Subconscious clues', tag3: 'Life direction'
    },
    career: {
      title: 'Career and Wealth Advisor', feature1: 'Wealth paths', feature2: 'Decision prompts', name: 'Master Qiance',
      summary: 'Clarify momentum and recognize both risks and opportunities.', tag1: 'Career momentum', tag2: 'Financial habits', tag3: 'Risk awareness'
    },
    sign: {
      title: 'Fortune Slip Guide', feature1: 'Today’s slip', feature2: 'Question guidance', name: 'The Oracle',
      summary: 'Draw a slip and gain a small insight for the choice ahead.', tag1: 'Daily questions', tag2: 'Action prompts', tag3: 'Decision support'
    },
    relief: {
      title: 'Clarity Companion', feature1: 'Supportive dialogue', feature2: 'Action list', name: 'Zhizhi',
      summary: 'Set the confusion down and find the next step you can take.', tag1: 'Relationship clarity', tag2: 'Choice support', tag3: 'Next steps'
    }
  },
  admin: {
    eyebrow: 'Internal tools', title: 'Activation Codes', description: 'Generate activation codes, review usage, and export filtered results.',
    passwordTitle: 'Enter administrator password', passwordDescription: 'This internal page is available only through its direct link. Verify the password to view data or generate codes.',
    password: 'Administrator password', passwordPlaceholder: 'Enter administrator password', verifying: 'Verifying...', enter: 'Open management page',
    generateTitle: 'Generate activation codes', generateDescription: 'Codes contain 6 random letters and digits and can be exported to Excel by batch.',
    latestBatch: 'Latest batch: {batch}, {quantity} codes.', quantity: 'Quantity', channel: 'Channel', channelPlaceholder: 'Optional; default is DEFAULT',
    generating: 'Generating...', generateDownload: 'Generate and download Excel', activationList: 'Activation code list', allStatuses: 'All statuses',
    unused: 'Unused', used: 'Activated', expired: 'Expired', pageSize: '{size} per page', refreshing: 'Refreshing...', refresh: 'Refresh',
    export: 'Export current list', activationCode: 'Activation code', status: 'Status', batchNo: 'Batch', userId: 'User ID', contact: 'Phone / Email',
    activatedAt: 'Activated at', createdAt: 'Created at', previous: 'Previous', next: 'Next', page: 'Page {page} of {pages}, {total} records',
    tokenList: 'Token usage', action: 'Action', model: 'Model', inputToken: 'Input tokens', outputToken: 'Output tokens', totalToken: 'Total tokens',
    recordedAt: 'Recorded at', inputOutput: 'Input / Output', passwordRequired: 'Enter the administrator password', verified: 'Verified', quantityInvalid: 'Enter a valid quantity',
    generated: 'Activation codes generated; download started', excelMissing: 'The API did not return Excel data', exportEmpty: 'There is no data to export', exported: 'Current list exported'
  }
};

export const messages = {
  'zh-CN': zhCN,
  'zh-TW': zhTW,
  'en-US': enUS
};
